<h1 translate
    matDialogTitle>
    processes_settings_title
</h1>

<form (submit)="onSubmit()">
    <mat-dialog-content>
        <ui-process-settings #processSetting
                             [state]="context.data.processSettings">
        </ui-process-settings>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{'modal_action_cancel' | translate}}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            processSetting.form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="process-settings-submit">
            {{'modal_action_update' | translate}}
        </button>
    </mat-dialog-actions>
</form>
